export default __webpack_public_path__ + "static/media/02.22d76a91.jpg";